import { render } from "./IndexLayout.vue?vue&type=template&id=9bd9503a"
import script from "./IndexLayout.vue?vue&type=script&lang=js"
export * from "./IndexLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__